import { Button, Upload } from 'antd';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import defaultProfile from '../../../../src/assets/images/default.jpg';
import apiCalls from 'src/api/apiCalls';
import { useSelector } from 'react-redux';
import { isErrorMessage } from 'src/components/shared/error.message';
import Loader from "src/components/loader.component";
const ProfileUpload = ({ handleError }) => {
    const fileInputRef = useRef(null);
    const [profileLoader, setProfileLoader] = useState(false);
    const [uploadLoader, setUploadLoader] = useState(false);
    const [profileGetData, setProfileGetData] = useState(null);
    const userDetails = useSelector(state => state.oidc?.adminDetails?.currentUser)
    const shouldLog=useRef(true)
    useEffect(() => {
        if (userDetails) {
            if (shouldLog.current) {
                shouldLog.current = false;
                getProfile(userDetails?.id);
            }
        }
    }, [userDetails]);
    const getProfile = async (id) => {
        setProfileLoader(true);
        handleError(null);
        try {
            const response = await apiCalls.getProfileImage(id);
            if (response) {
                setProfileGetData(processImage(response?.data));
            } else {
                handleError(isErrorMessage(response?.data));
            }
        } catch (error) {
            handleError(error);
        }
        setProfileLoader(false);
    };
    const processImage = (image) => {
        if (image?.type === 2) {
            try {
                const cleanedBase64 = image?.fileContent.replace(/[^A-Za-z0-9+/]/g, '');
                const binaryString = atob(cleanedBase64);
                const byteArray = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    byteArray[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([byteArray], { type: 'image/png' });
                return { fileUrl: URL.createObjectURL(blob), docType: image?.documentType };
            } catch (error) {
                handleError(error);
            }
        }
        return null;
    };

    const handleImageChange = useCallback(async ({ file }) => {
        setUploadLoader(true);
        const image = file.originFileObj;
        if (!image) {
            setUploadLoader(false);
            return;
        }
        const allowedTypes = ["image/png", "image/jpg", "image/jpeg"];
        if (image.size > 25000000) {
            handleError("File size exceeds the maximum allowed (25MB).");
            setUploadLoader(false);
            return;
        }
        if (!allowedTypes.includes(image.type)) {
            handleError("File is not allowed. You can upload jpg, png.");
            setUploadLoader(false);
            return;
        }
        const formData = new FormData();
        formData.append("type", 2);
        formData.append("ImageContent", image, image.name);
        try {
            const response = await apiCalls.uploadProfile(formData);
            if (response) {
                await getProfile(userDetails?.id);
                fileInputRef.current.value = null;
            }
        } catch (error) {
            handleError(error);
        } finally {
            setUploadLoader(false);
        }
    }, [handleError, userDetails?.id]);

    return (
        <>
            <div className='flex justify-center items-center'>
                <div className='user-profile !relative'>
                    <div className=' border-2 border-inputBorder rounded-full w-32 h-32 flex items-center justify-center img-upload'>
                        {(!profileLoader && !uploadLoader) && (
                            <img
                                src={profileGetData?.fileUrl || defaultProfile}
                                className="rounded-full w-28 h-28 object-cover overflow-hidden mx-auto"
                                alt="img"
                            />
                        )}
                    </div>
                    <Upload
                        ref={fileInputRef}
                        onChange={handleImageChange}
                        accept=".png,.jpeg,.jpg,.JPG,.JPEG,.PNG"
                        className=''
                    >
                        <Button
                            shape="circle"
                            type=""
                            className="bg-inputBorder !border-inputBorder absolute bottom-3 right-3 flex justify-center items-center hover:!bg-none"
                            size="large"
                            icon={<span className="icon camera" />}
                        />
                        <div className='absolute top-[20%] right-[80px]'>
                            {(profileLoader || uploadLoader)&& <Loader className="" />}
                        </div>
                    </Upload>
                </div>
            </div>
        </>
    );
};
export default ProfileUpload;
